import React, { useCallback } from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';

import { Button } from '..';
import { changeZindex } from './lightHouse';

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  root: {
    fontFamily: 'Montserrat',
    '&:hover': {
      backgroundColor: palette.buttonAction.background,
    },
  },
}), { name: 'HelpDocAction' });

type Props = {
  title: React.ReactNode;
  page?: 'article' | 'category' | 'contact' | 'home' | 'suggestions';
  id?: string;
};

const HelpDocAction = ({ title, page = 'article', id }: Props) => {
  const classes = useStyles();

  const onClick = useCallback(() => {
    if (window.Lighthouse) {
      changeZindex('2147483647');
      window.Lighthouse.navigate(page, id);
    }
  }, [page, id]);

  return (
    <Button
      classes={{
        root: classes.root,
      }}
      onClick={onClick}
      color="primary"
      variant="contained"
    >
      {title}
    </Button>
  );
};

export default HelpDocAction;
